<template>
  <div v-if="options.isDownloadDialog" class="login_wrapper_h">
    <div class="login_box_h login_in">
        <span class="login_close" @click="closeDownloadDialog">
          <i></i>
        </span>
      <div class="dialog_download">
        <span>遊戲下載</span>
        <div v-if="linksList.length>0" class="d_in">
          <a v-for="value in linksList" v-if="value.channel.name.toLowerCase() !== 'facebook' && value.channel.name.toLowerCase() !== 'youtube'" :class="'btn'+value.channel.name.toLowerCase()" :href="value.url"></a>
          <div v-for="value in linksList" v-if="linksList.length===1 && value.channel.name.toLowerCase() === 'facebook'" class="d_in">
            暫無數據~
          </div>
        </div>
        <div v-else class="d_in">
          暫無數據~
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../assets/styles/login.css'

export default {
  name: 'DownloadDialog',
  props: {
    options: Object,
    isFbDialog: Boolean
  },
  computed: {},
  data: function () {
    return {
      linksList: []
    }
  },
  created() {
    this.$bus.on('downloadSend', (linksArr) => {
      this.linksList = linksArr
    })
  },
  mounted() {
  },
  methods: {
    closeDownloadDialog: function () {
      this.$emit('closeDownloadDialog')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/styles_m/varibles.styl';

@keyframes fadeIn {
  0% {
    transform: scale(0.3);
  }

  100% {
    transform: scale(1);
  }
}

.v-enter-active {
  animation: fadeIn 0.3s;
}

.v-leave-active {
  animation: fadeIn 0.3s reverse;
}

.login_wrapper_h {
  position: relative;
  width: 100%;

  .btn_login, .el-form-item {
    margin-bottom: 0 !important;
  }

  .forgetPassword {
    input[name='checkbox'] {
      margin-top: 12px !important;
      margin-right: 9px !important;
    }
  }

  .login_box_h {
    position: fixed;
    z-index: 122;
    width: 5.73rem;
    left: 50%;
    top: 50%;
    margin-left: -45%;
    margin-top: -30%;
    border-radius: $bdRadius;
    text-align: center;
    background: #ebf0f3;
    border: 0.03rem solid #c0bfbf;

    .dialog_download {
      margin: 0.56rem auto;
      text-align: center;

      .d_in {
        width: 3.04rem;
        margin: .3rem auto;

        a {
          width: 100%;
          height: 1rem;
          left: 0;
          background: url('../../assets/imgs_m/download_bg.png') no-repeat center;
          background-size: 3.04rem 3.53rem;
          margin-bottom: .26rem;

          &:last-child {
            margin-bottom: 0
          }

          &.btnappstore {
            background-position: 0 0;
          }

          &.btngoogleplay {
            background-position: 0 -1.32rem;
          }

          &.btnapk {
            background-position: 0 -2.51rem;
          }
        }
      }

      span, a {
        display: inline-block;
      }

      span {
        font-size: 0.33rem;
        color: #434341;
      }
    }

    .login_close {
      position: absolute;
      width: 0.41rem;
      height: 0.41rem;
      right: 0.27rem;
      top: 0.27rem;
      background: url('../../assets/imgs_m/d_close.png') no-repeat center;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
}

.login_wrapper_h >>> .swiper-container {
  position: absolute;
  list-style: none;
  padding: 0;
  z-index: 0;
  width: 690px;
  height: 173px;
  left: 50%;
  top: 72px;
  margin-left: -345px;
}

.login_wrapper_h >>> .swiper-slide {
  width: 126px;
  height: 126px;
  text-align: center;
  margin-left: 11px;
}

.login_wrapper_h >>> .swiper-slide div {
  width: 126px;
  height: 126px;
}

.login_wrapper_h >>> .swiper-slide p {
  color: #333333;
  font-size: 16px;
  margin-top: 10px;
}

.login_wrapper_h >>> .swiper-slide img {
  width: 126px;
  height: 126px;
  border-radius: 36px;
  transition: transform 0.9s ease 0s;
}

.login_wrapper_h >>> .swiper-slide img:hover {
  transform: scale(1.05, 1.05);
  animation: 0.9s ease-in-out;
}

.swiper-button-prev {
  width: 45px !important;
  height: 61px !important;
  background: url('../../assets/imgs/prevfb.png') no-repeat !important;
  background-size: 100% 100% !important;
  left: 17px !important;
  outline: none !important;
  margin-top: -2px !important;
}

.swiper-button-next {
  width: 45px !important;
  height: 61px !important;
  background: url('../../assets/imgs/nextfb.png') no-repeat !important;
  background-size: 100% 100% !important;
  right: 17px !important;
  outline: none !important;
  margin-top: -2px !important;
}

.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
  content: '';
}

.swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
  content: '';
}
</style>
